import { MAJORCLARITY_LOGGING_URL, MC_TOKEN } from './auth0Config'

class LoggerService {

  public async logRequest(loggerObject): Promise<void> {
    try {
      await fetch(MAJORCLARITY_LOGGING_URL, {
        method: 'POST',
        mode: 'cors',
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + MC_TOKEN 
        },
        body: JSON.stringify({logger_object: loggerObject})
      })
    } catch (error) {
      console.error('Error occurred during logout:', error)
    }
  }
}

export default LoggerService
